"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateVirtualCategory = void 0;
const routes_1 = require("../../routes");
const updateVirtualCategory = (client) => async (params, data) => {
    const url = routes_1.ENDPOINTS.UPDATE_VIRTUAL_CATEGORY.applyParams(params);
    const response = await client.put(url, data);
    return response.data;
};
exports.updateVirtualCategory = updateVirtualCategory;
